import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HostelService {

    constructor(private http: CustomHttpService) { }

    getAllHostelCategoriesWithCount(params: any): Observable<any> {
        return this.http.post(environment.getAllHostelCategoriesWithCount, params);
    }

    createHostelCategory(data: any): Observable<any> {
        return this.http.post(environment.createHostelCategory, data);
    }

    updateHostelCategory(data: any): Observable<any> {
        return this.http.post(environment.updateHostelCategory, data);
    }

    deleteHostelCategory(data: any): Observable<any> {
        return this.http.post(environment.deleteHostelCategory, data);
    }

    getAllHostelCategories(params: any): Observable<any> {
        return this.http.post(environment.getAllHostelCategories, params);
    }
}